import React from 'react';
import { Link } from 'react-router-dom';
import Icon404 from '@/assets/icons/404.svg';
import { Button } from 'react-bootstrap';
import styles from './404.module.scss';
import {LanguageHelper} from '@/languages/helper';

const NotFoundComponent = () => (
  <div className="padding-x d-flex flex-column py-5 my-5 justify-content-center align-items-center">
    <Icon404/>
    <h5 className="py-5 text-muted font-weight-normal">{LanguageHelper('organismsTranslations.missingContent')}</h5>
    <Button variant="outline-primary" className={`${styles.cg404__button} px-5 py-2 font-weight-bold`} as={Link} to="/">
      <span className={`${styles.cg404__buttonText} px-5`}>{LanguageHelper('organismsTranslations.backHome')}</span>
    </Button>
  </div>
)

export default NotFoundComponent;
